import axios from 'axios';
import { appUrl } from '../../../../../utils/config';
import {
  MFG_DASHBOARD_REQUEST, MFG_DASHBOARD_SUCCESS, MFG_DASHBOARD_FAILURE,
  MFG_QUICK_SUMMARY_REQUEST, MFG_QUICK_SUMMARY_SUCCESS, MFG_QUICK_SUMMARY_FAILURE,
  MFG_SET_SELECTED_BATCH,
  MFG_CMO_LIST_REQUEST, MFG_CMO_LIST_SUCCESS, MFG_CMO_LIST_FAILURE,
  MFG_PLANTS_REQUEST, MFG_PLANTS_SUCCESS, MFG_PLANTS_FAILURE,
  MFG_BRANDS_REQUEST, MFG_BRANDS_SUCCESS, MFG_BRANDS_FAILURE,
  MFG_PRODUCT_TYPES_REQUEST, MFG_PRODUCT_TYPES_SUCCESS, MFG_PRODUCT_TYPES_FAILURE,
  MFG_SAVED_FILTERS,
} from '../types';
import { fetchAllDashboardFilters, extractDashboardFilters, saveDashboardFilters } from '../../utils/filterUtils';

export let mfgDashboardSource;
export const fetchMfgDashboard = (data) => (dispatch) => {
  dispatch({ type: MFG_DASHBOARD_REQUEST });
  const CancelToken = axios.CancelToken;
  mfgDashboardSource = CancelToken.source();

  const appName = localStorage.getItem('appName');
  const network = localStorage.getItem('network');
  const collabType = localStorage.getItem('collabType');
  const roleName = localStorage.getItem('roleName');

  axios.post(
    `${appUrl}/${appName}/${network}/${collabType}/${roleName}/fetchMfgCollabDashboard`,
    data,
    { cancelToken: mfgDashboardSource.token }
  )
  .then((res) => {
    if (res?.data?.status) {
      dispatch({ type: MFG_DASHBOARD_SUCCESS, payload: res.data });
    }
  })
  .catch((err) => {
    if (!axios.isCancel(err)) {
      dispatch({ type: MFG_DASHBOARD_FAILURE, payload: err });
    }
  });
};

export let mfgQuickSummarySource;
export const fetchMfgQuickSummary = (data) => (dispatch) => {
  dispatch({ type: MFG_QUICK_SUMMARY_REQUEST });
  const CancelToken = axios.CancelToken;
  mfgQuickSummarySource = CancelToken.source();

  const appName = localStorage.getItem('appName');
  const network = localStorage.getItem('network');
  const collabType = localStorage.getItem('collabType');
  const roleName = localStorage.getItem('roleName');

  axios.post(
    `${appUrl}/${appName}/${network}/${collabType}/${roleName}/fetchMfgQuickSummary`,
    data,
    { cancelToken: mfgQuickSummarySource.token }
  )
  .then((res) => {
    if (res?.data?.status) {
      dispatch({ type: MFG_QUICK_SUMMARY_SUCCESS, payload: res.data.quickSummary });
    }
  })
  .catch((err) => {
    if (!axios.isCancel(err)) {
      dispatch({ type: MFG_QUICK_SUMMARY_FAILURE, payload: err });
    }
  });
};

export const setSelectedBatch = (batch) => (dispatch) => {
  dispatch({ type: MFG_SET_SELECTED_BATCH, payload: batch });
};

// ─── Dropdown filter actions ────────────────────────────────────────────────

const getApiBase = () => {
  const appName = localStorage.getItem('appName');
  const network = localStorage.getItem('network');
  const collabType = localStorage.getItem('collabType');
  const roleName = localStorage.getItem('roleName');
  return `${appUrl}/${appName}/${network}/${collabType}/${roleName}`;
};

export const fetchMfgCMOList = () => (dispatch) => {
  dispatch({ type: MFG_CMO_LIST_REQUEST });
  axios.get(`${getApiBase()}/fetchAllVendorPlants`)
    .then((res) => {
      if (res?.data?.status) {
        // Extract unique CMOs from vendor plant details
        const plants = res.data.vendorPlantDetails || [];
        const cmoMap = {};
        plants.forEach((p) => {
          if (p.vendorMosymphonyID && !cmoMap[p.vendorMosymphonyID]) {
            cmoMap[p.vendorMosymphonyID] = p.vendorName || `CMO-${p.vendorMosymphonyID}`;
          }
        });
        const cmoList = Object.entries(cmoMap).map(([id, name]) => ({ id, name }));
        dispatch({ type: MFG_CMO_LIST_SUCCESS, payload: cmoList });
      }
    })
    .catch((err) => {
      dispatch({ type: MFG_CMO_LIST_FAILURE, payload: err });
    });
};

export const fetchMfgPlants = () => (dispatch) => {
  dispatch({ type: MFG_PLANTS_REQUEST });
  axios.get(`${getApiBase()}/fetchMfgPlants`)
    .then((res) => {
      if (res?.data?.status) {
        const plants = res.data.MfgPlantsDetails || [];
        dispatch({ type: MFG_PLANTS_SUCCESS, payload: plants });
      }
    })
    .catch((err) => {
      dispatch({ type: MFG_PLANTS_FAILURE, payload: err });
    });
};

export const fetchMfgBrands = () => (dispatch) => {
  dispatch({ type: MFG_BRANDS_REQUEST });
  axios.get(`${getApiBase()}/fetchAllBrands`)
    .then((res) => {
      if (res?.data?.status) {
        dispatch({ type: MFG_BRANDS_SUCCESS, payload: res.data.data?.Brands || res.data.data?.brandList || res.data.data || [] });
      }
    })
    .catch((err) => {
      dispatch({ type: MFG_BRANDS_FAILURE, payload: err });
    });
};

export const fetchMfgProductTypes = (productConfig = 'true') => (dispatch) => {
  dispatch({ type: MFG_PRODUCT_TYPES_REQUEST });
  axios.get(`${getApiBase()}/fetchProductTypes/${productConfig}`)
    .then((res) => {
      if (res?.data?.status) {
        dispatch({ type: MFG_PRODUCT_TYPES_SUCCESS, payload: res.data.data?.productTypeList || res.data.data || [] });
      }
    })
    .catch((err) => {
      dispatch({ type: MFG_PRODUCT_TYPES_FAILURE, payload: err });
    });
};

// ─── Save / Clear / Fetch saved filters ─────────────────────────────────────

export const fetchMfgCollabSavedFilters = () => async (dispatch) => {
  try {
    const allFilters = await fetchAllDashboardFilters();
    const mfgFilters = extractDashboardFilters(allFilters, 'manufacturingCollaborationDashboard');
    dispatch({ type: MFG_SAVED_FILTERS, payload: mfgFilters });
    return mfgFilters;
  } catch (err) {
    console.error('Error fetching mfg collab filters:', err);
    dispatch({ type: MFG_SAVED_FILTERS, payload: { status: false } });
    return { status: false };
  }
};

export const saveMfgCollabFilters = (filterData) => async (dispatch) => {
  try {
    const result = await saveDashboardFilters('manufacturingCollaborationDashboard', filterData);
    dispatch(fetchMfgCollabSavedFilters());
    return result;
  } catch (err) {
    console.error('Error saving mfg collab filters:', err);
    return { status: false, message: 'Failed to save filters.' };
  }
};

export const clearMfgCollabFilters = () => async (dispatch) => {
  try {
    const emptyFilters = {
      vendorMosymphonyID: 'all',
      mfgPlant: 'all',
      brand: 'all',
      productType: 'all',
    };
    const result = await saveDashboardFilters('manufacturingCollaborationDashboard', emptyFilters);
    dispatch({ type: MFG_SAVED_FILTERS, payload: { status: true, save_filter_options: emptyFilters } });
    return result;
  } catch (err) {
    console.error('Error clearing mfg collab filters:', err);
    return { status: false, message: 'Failed to clear filters.' };
  }
};

// ─── Update PO / Batch Status ───────────────────────────────────────────────

export const updatePOStatus = (payload) => async (dispatch) => {
  try {
    const url = `${getApiBase()}/purchaseOrderUpdateStatus`;
    const response = await axios.post(url, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};
